export default "__VITE_ASSET__0958d341__"